<template>
  <div class="ticket-detail">
    <div class="ticket-detail-head">
      <bcc-breadcrumb>
        <bcc-breadcrumb-item>管理中心</bcc-breadcrumb-item>
        <bcc-breadcrumb-item :to="{name: 'ticket'}" @click.native="$LogReport.sendCustomEvent('openplat_ticketdetail_backto_ticketmanage')">工单管理</bcc-breadcrumb-item>
        <bcc-breadcrumb-item>工单详情</bcc-breadcrumb-item>
      </bcc-breadcrumb>
    </div>
    <div class="ticket-detail-body">
      <div class="ticket-detail-body-h">
        <h3 class="txt">工单详情</h3>
        <span v-html='renderState'></span>
        <span class="time">{{ctime || '-'}}</span>
      </div>
      <div class="ticket-detail-body-b">
        <div class="ticket-detail-des">
          <div class="ticket-desc-title">
            <div class="column">
              <span>工单类型：</span>
              <span class="ctime">{{this.$route.params.name || '-'}}</span>
            </div>
             <div class="column">
              <span>手机：</span>
              <span class="ctime">{{ticket.mobile || '-'}}</span>
            </div>
            <div class="column">
              <span>邮箱：</span>
              <span class="ctime">{{ticket.email || '-'}}</span>
            </div>
             <div class="column">
              <span>复现概率：</span>
              <span class="ctime">{{ticket.frequency || '-'}}</span>
            </div>
          </div>
          <div class="cm-line">问题描述：</div>
          <div class="cm-content">{{ticket.des || '-'}}</div>
          <div class="cm-line">相关附件：</div>
          <div v-if='ticket.url'>
            <img v-if="['png', 'jpg', 'jpeg'].includes(ticket.url.split('.').pop())" @click="handleImage(ticket.url)" class="attach-img" :src="ticket.url" alt="">
            <a class="cm-content" target="_blank" v-else :href="ticket.url">查看附件</a>
          </div>
          <span v-else>暂无附件</span>
          <div class="ticket-detail-des-content">{{ticket.title}}</div>
        </div>
        <span style="color: #505050; font-weight: bold; font-size: 16px">沟通记录</span>
        <div class="ticket-detail-conversation">
          <span class="blank" v-if="conversation.length === 0">暂无记录</span>
          <div v-else v-for="round in conversation" :key="round.ctime" class="conversation-round">
            <div class="round-head">
              {{round.reply_id === mid ? '[用户]' : '[开放平台]'}}
              <span class="time">{{renderTime(round.ctime)}}</span>
            </div>
            <div class="round-content">{{round.content}}</div>
            <img v-if='round.img_url' @click="handleImage(round.img_url)" class="round-img" :src="round.img_url" alt="">
          </div>
        </div>
        <div class="reply-box" v-if='[0,1,2].includes(+this.$route.query.state)'>
          <bcc-input type="textarea" rows="1" v-model="replyMessage" style="width: 976px" placeholder="在此输入回复内容" class="input-box"></bcc-input>
          <v-icon class="send-img"  @click="selectFile" name="upload"></v-icon>
          <bcc-button type="primary" :disabled="replyMessage.trim() ===''" @click="sendReply">发表回复</bcc-button>
        </div>
      </div>
    </div>
    <div style="text-align: center; margin-top: 50px">
      <router-link :to="{name: 'ticket'}" @click.native="$LogReport.sendCustomEvent('openplat_ticketdetail_backtolist_click')">
        <bcc-button>返回工单列表</bcc-button>
      </router-link>
    </div>
     <input
      accept=".jpg,.jpeg,.png"
      ref="input"
      type="file"
      style="display: none"
      @change="onFileSelected"
    />
  </div>
</template>

<script>
import {login} from "@/utils/login";

export default {
  name: "detail",
  data() {
    return {
      showSecret: false,
      app_name: '',
      secret: '',
      cover: '',
      client_id: this.$route.params.client_id,
      app_type: 1,
      web_app_info: null,
      app_info: null,
      user_info: null,
      state: null,
      ticket: {},
      ctime: '',
      conversation: [],
      mid: '',
      replyMessage: ''
    }
  },
  computed: {
    renderState() {
      switch (+this.$route.query.state) {
        case 0:
          return '<span style="color: #FAAB4B;">待处理</span>'
        case 1:
          return '<span style="color: #FAAB4B;">处理中</span>'
        case 2:
          return '<span style="color: #8BE09C">处理中</span>'
        case 3:
          return '<span style="color: gray;">已完结</span>'
        case 5:
          return '<span style="color: gray;">已完结</span>'
        case 100:
          return '<span style="color: gray;">已删除</span>'
        default:
          return '<span style="color: #FA5A57;">未知状态(-1)</span>'
      }
    },
  },
  created() {
    if (this.$store.state.userInfo) {
      this.mid = this.$store.state.userInfo.mid.toString()
      this.$LogReport.sendCustomEvent('openplat_checkticketdetail_page_load')
      this.getTicketDetail().catch(e => {
        this.$message({
          content: e.message,
          type: 'exception',
          offset: 60,
          duration: 1500
        })
      })
    } else {
      this.$router.push({
        name: 'home'
      })
      login()
    }
  },
  methods: {
    selectFile () {
      const input = this.$refs['input']
      input.value = null
      this.$refs['input'].click()
    },
    onFileSelected(e) {
      const file = e.target.files[0]
      if (file.size > 10 * 1024 * 1024) {
        this.$message({
          content: '附件体积过大，请重新上传',
          type: 'exception',
          offset: 60,
          duration: 1500
        })
        return
      }
      this.file = file
      this.uploadFile(file)
    },
     async uploadFile(file) {
      if (!file) return
      return await this.$api.ticket.upload(file).then(async(data) => {
        let res = await this.$api.ticket.sendReply({
          content: '',
          session_id: this.$route.params.ticket_id,
          mid: this.$store.state.userInfo.mid,
          img_url: data.url,
          platform: 'open-platform'
        })
        if (res.code === 18005) {
          this.$message({
            content: '工单已完结',
            type: 'exception',
            offset: 60,
            duration: 1500
          })
          this.$router.push({ name: 'ticket' })
          return
        }
        await this.getTicketDetail()
      }).catch(e => {
        console.error(e)
        this.$message({
          content: '文件上传失败，请重试',
          type: 'exception',
          offset: 60,
          duration: 1500
        })
      })
    },
    handleImage (img) {
      window.open(img)
    },
    async getTicketDetail() {
      try {
        this.conversation = await this.$api.ticket.view({
          session_id: this.$route.params.ticket_id,
          mid: this.$store.state.userInfo.mid
        }) || []
        this.ticket = JSON.parse(this.conversation[0].content)
        this.ctime = this.renderTime(this.conversation[0].ctime)
        this.conversation = this.conversation.splice(1)
      }catch (e){
        this.$message({
          content: e.message,
          type: 'exception',
          offset: 60,
          duration: 1500
        })
      }
    },
    renderTime(time) {
      return window.moment.unix(time).format('YYYY-MM-DD HH:mm')
    },
    async sendReply() {
      try {
        let res = await this.$api.ticket.sendReply({
          content: this.replyMessage,
          session_id: this.$route.params.ticket_id,
          mid: this.$store.state.userInfo.mid,
          img_url: this.img_url,
          platform: 'open-platform'
        })
        if (res.code === 18005) {
          this.$message({
            content: '工单已完结',
            type: 'exception',
            offset: 60,
            duration: 1500
          })
          this.$router.push({ name: 'ticket' })
          return
        }
        this.replyMessage = ''
        await this.getTicketDetail()
      }catch (e){
        this.$message({
          content: e.message,
          type: 'exception',
          offset: 60,
          duration: 1500
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.ticket-detail {
  min-width: 960px;
  width: 100%;
  max-width: 1168px;
  margin: auto;
  padding-bottom: 32px;
}
.ticket-detail-head {
  padding: 32px 0 34px 26px;
}
.ticket-detail-body {
  word-break: break-all;
  border: 1px solid #E7E7E7;
  min-height: 100px;
  .ticket-detail-body-h {
    padding: 25px 26px 16px;
    border-bottom: 1px solid #E7E7E7;
    display: flex;
    align-items: center;
    color: #999999;
    font-size: 14px;
    h3 {
      font-size: 18px;
      color: #333;
      flex: 1;
    }
    .time {
      padding-left: 15px;
    }
  }
  .ticket-detail-body-b {
    padding: 38px 34px 24px;
    .ticket-detail-des{
      margin-bottom: 38px;
      color: rgb(80, 80, 80);
      .ticket-desc-title{
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        .column {
          span {
            &:first-child {
              font-weight: bold;
            }
          }
        }
        .ctime{
          color: #999999;
          font-size: 14px;
        }
      }
      .cm-line {
        color: rgb(80, 80, 80);
        margin: 20px 0 10px;
        font-weight: bold;
      }
      .attach-img {
        height: 60px;
        cursor: pointer;
      }
      .cm-content {
        font-size: 14px;
        color: #999999;
      }
      .ticket-detail-des-content{
        margin-top: 16px;
        font-size: 14px;
        color: #505050;
      }
    }
    .ticket-detail-conversation{
      margin-top: 16px;
      margin-bottom: 24px;
      background: #FAFAFA;
      padding: 33px 32px;
      .blank{
        color: #505050;
        font-size: 14px;
      }
      .conversation-round{
        margin-bottom: 28px;
        color: #505050;
        font-size: 14px;
        .round-head{
          margin-bottom: 12px;
          font-weight: bold;
          .time{
            margin-left: 20px;
            color: #999999;
          }
        }
        .round-content{
          line-height: 24px;
        }
        .round-img {
          height: 24px;
          cursor: pointer;
        }
      }
    }
    .reply-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      .send-img {
        position: absolute;
        right: 130px;
        top: 10px;
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
    }
    .bcc-input-inner.textarea {
      padding-right: 35px;
    }
  }
}
</style>
